import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import Steps from '../../components/Steps/Steps';
import { IoIosArrowForward } from 'react-icons/io';
import SelectedPlan from '../../components/SelectedPlan/SelectedPlan';

class Payment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            step: 3,
        }
    }

    componentDidMount(){
        
        this.props.history.push("/payment/credit-card");
        
    }

    render(){

        if(!localStorage.getItem("token")){
            return (
                <Redirect to="/" />
            )
        }

        return (
            <div className="page-container page">

                <SelectedPlan />

                <div className="position-relative">
                    <div className="p-5">
                        
                        <h6 className="text-center pb-3">Escolha como prefere fazer o pagamento</h6>

                        <div className="menu-list">
                            <Link to="/payment/credit-card">
                                <div className="menu-list--item">
                                    <h2>Cartão de crédito</h2>
                                    <p>Aceitamos Visa, Master, ELO...</p>
                                    <IoIosArrowForward />
                                </div>
                            </Link>
                            <Link to="/payment/boleto">
                                <div className="menu-list--item">
                                    <h2>Boleto bancário</h2>
                                    <p>Sugeita análise para aprovação</p>
                                    <IoIosArrowForward />
                                </div>
                            </Link>
                            <Link to="/payment/pix">
                                <div className="menu-list--item">
                                    <h2>PIX</h2>
                                    <p>Rápido e fácil!</p>
                                    <IoIosArrowForward />
                                </div>
                            </Link>
                        </div>
                        
                    </div>
                </div>
            </div>
        )
    }

}

export default Payment;